import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { translate } from 'react-i18next'

import * as trackingMonitorActions from 'action/trackingMonitor'

import ContentHeader from 'component/utils/ContentHeader'
import Breadcrumb from 'component/Breadcrumb'
import Grid from 'component/utils/Grid'
import Row from 'component/utils/Row'
import Col from 'component/utils/Col'
import Table from 'component/trackingMonitor/Table'
import StoreFilter from 'component/trackingMonitor/StoreFilter'
import RemoveModal from 'component/trackingMonitor/RemoveModal'
import ViewModal from 'component/trackingMonitor/ViewModal'
import SuccessModal from 'component/Modal/SuccessModal'
import ErrorModal from 'component/trackingMonitor/ErrorModal'

class TrackingMonitorContainer extends PureComponent {
  static propTypes = {
    auth: PropTypes.object.isRequired,
    error: PropTypes.object,
    fetchRemovalReasonList: PropTypes.func.isRequired,
    fetchSalesOrderList: PropTypes.func.isRequired,
    isSaving: PropTypes.bool.isRequired,
    removalReasonList: PropTypes.array.isRequired,
    remove: PropTypes.func.isRequired,
    salesOrderList: PropTypes.array.isRequired,
    translate: PropTypes.func.isRequired,
  }

  constructor() {
    super()

    this.state = {
      openErrorModal: false,
      openRemoveModal: false,
      openSuccessModal: false,
      openViewModal: false,
      record: null,
      store: null,
      storeFull: null,
    }
  }

  componentDidMount() {
    const { auth, fetchRemovalReasonList, fetchSalesOrderList } = this.props

    if (auth.user.locationCode !== '999') {
      this.setState({
        store: auth.user.locationCode,
        storeFull: `${auth.user.locationCode} - ${auth.user.locationName}`,
      })
      const param = {
        store: auth.user.locationCode,
        storeFull: `${auth.user.locationCode} - ${auth.user.locationName}`,
      }
      fetchSalesOrderList(auth.user.totemToken, param)
    }

    fetchRemovalReasonList(auth.user.totemToken)
  }

  fetchSalesOrderList = (values) => {
    const { auth, fetchSalesOrderList } = this.props

    const { store } = this.state

    const param = { ...values }

    if (values.store) {
      this.setState({ store: values.store })
    } else {
      param.store = store
    }

    fetchSalesOrderList(auth.user.totemToken, param)

    if (values.storeFull) {
      this.setState({ storeFull: values.storeFull })
    }
  }

  renderTable = () => {
    const { salesOrderList, translate } = this.props

    const { storeFull } = this.state

    return (
      <Table
        onSubmit={this.fetchSalesOrderList}
        openRemoveModal={this.openRemoveModal}
        openViewModal={this.openViewModal}
        records={salesOrderList}
        storeFull={storeFull}
        translate={translate}
      />
    )
  }

  openRemoveModal = (record) => {
    this.setState({ openRemoveModal: true, record })
  }

  openViewModal = (record) => {
    this.setState({ openViewModal: true, record })
  }

  renderStoreFilter = () => {
    const { translate } = this.props

    return (
      <Grid fluid>
        <Row>
          <Col xs={12} className='margin-top-double'>
            <h3>{translate('totem.trackingMonitor.title')}</h3>
          </Col>
        </Row>

        <Row>
          <Col xs={12}>
            <StoreFilter
              onSubmit={this.fetchSalesOrderList}
              translate={translate}
            />
          </Col>
        </Row>
      </Grid>
    )
  }

  renderRemoveModal = () => {
    const { removalReasonList, translate } = this.props

    const { openRemoveModal, record } = this.state

    if (!openRemoveModal) return

    return (
      <RemoveModal
        closeModal={this.closeRemoveModal}
        onSubmit={this.remove}
        record={record}
        removalReasonList={removalReasonList}
        translate={translate}
      />
    )
  }

  closeRemoveModal = () => {
    this.setState({ openRemoveModal: false })
  }

  remove = (values) => {
    const { auth, remove } = this.props

    const params = { ...values, lastUserCd: auth.user.username }

    remove(auth.user.totemToken, params, this.removeSuccess, this.removeError)
  }

  removeSuccess = () => {
    this.closeRemoveModal()

    this.fetchSalesOrderList({})

    this.openSuccessModal()
  }

  openSuccessModal = () => {
    this.setState({ openSuccessModal: true })
  }

  openErrorModal = () => {
    this.setState({ openErrorModal: true })
  }

  removeError = () => {
    this.closeRemoveModal()

    this.fetchSalesOrderList({})

    this.openErrorModal()
  }

  renderViewModal = () => {
    const { translate } = this.props

    const { openViewModal, record } = this.state

    if (!openViewModal) return

    return (
      <ViewModal
        closeModal={this.closeViewModal}
        record={record}
        translate={translate}
      />
    )
  }

  closeViewModal = () => {
    this.setState({ openViewModal: false })
  }

  renderSuccessModal = () => {
    const { translate } = this.props

    const { openSuccessModal, record } = this.state

    if (!openSuccessModal) {
      return
    }

    return (
      <SuccessModal
        handleClose={this.closeSuccessModal}
        t={translate}
        msg={
          <p>
            {`${translate('totem.trackingMonitor.modal.success.content.1')} `}
            <strong>{record.header.orderNumber}</strong>
            {` ${translate('totem.trackingMonitor.modal.success.content.2')}`}
          </p>
        }
        size='sm'
        center
        buttonText='OK'
      />
    )
  }

  closeSuccessModal = () => {
    this.setState({ openSuccessModal: false })
  }

  renderErrorModal = () => {
    const { translate } = this.props

    const { openErrorModal, record } = this.state

    if (!openErrorModal) {
      return
    }

    return (
      <ErrorModal
        closeModal={this.closeErrorModal}
        record={record}
        translate={translate}
      />
    )
  }

  closeErrorModal = () => {
    this.setState({ openErrorModal: false })
  }

  render() {
    const { translate } = this.props

    const { store } = this.state

    const BREADCRUMB_STEPS = [
      { link: '/', title: translate('mobile.home') },
      { title: translate('totem') },
      { title: translate('totem.trackingMonitor.title'), strong: true },
    ]

    return (
      <>
        <ContentHeader>
          {translate('totem.trackingMonitor.title')}
        </ContentHeader>

        <Breadcrumb steps={BREADCRUMB_STEPS} />

        {store ? this.renderTable() : this.renderStoreFilter()}

        {this.renderRemoveModal()}

        {this.renderViewModal()}

        {this.renderSuccessModal()}

        {this.renderErrorModal()}
      </>
    )
  }
}

/* istanbul ignore next */
const mapStateToProps = ({ trackingMonitorReducer }) => ({
  error: trackingMonitorReducer.error,
  isSaving: trackingMonitorReducer.isSaving,
  removalReasonList: trackingMonitorReducer.removalReasonList,
  salesOrderList: trackingMonitorReducer.salesOrderList,
})

/* istanbul ignore next */
const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ ...trackingMonitorActions }, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(translate(null, { wait: true })(TrackingMonitorContainer))

export { TrackingMonitorContainer }
